import { amendmentHistoryExternalOperatorsPageBreadcrumbs } from '../../../config/breadcrumbs';
import {
  AmendmentsSearchBar,
  AmendmentsTable,
} from '@/pages/Business/pages/Amendments/components';
import { useAmendmentHistory } from '@/pages/Business/pages/Amendments/hooks';
import { useNavigate } from 'react-router-dom';
import { NavigateLinks } from '@/components';
import { useMemo } from 'react';

const AmendmentHistory = () => {
  const navigate = useNavigate();

  const breadcrumbs = useMemo(
    () => amendmentHistoryExternalOperatorsPageBreadcrumbs(navigate),
    [navigate]
  );

  const {
    amendments,
    isLoading,
    totalItems,
    totalPages,
    currentPage,
    pageSize,
    filter,
    setFilter,
    handlePageChange,
    handlePageSizeChange,
  } = useAmendmentHistory();

  return (
    <section className='flex flex-col w-full h-full gap-10'>
      <NavigateLinks actualPage='Historial de enmiendas' breadcrumbs={breadcrumbs} />

      <AmendmentsSearchBar filter={filter} onSearch={setFilter} />

      <AmendmentsTable
        amendments={amendments}
        isLoading={isLoading}
        totalItems={totalItems}
        totalPages={totalPages}
        currentPage={currentPage}
        pageSize={pageSize}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
        shippingBaseUrl='/business-external-operators/shipping'
      />
    </section>
  );
};

export default AmendmentHistory;
